import { z } from "zod";

/**
 * Email field with standard validation
 */
export const emailField = z
  .string()
  .min(1, "Email is required")
  .max(254, "Email must be 254 characters or less")
  .email("Invalid email address");

/**
 * Email confirmation field (used with withEmailConfirmation refinement)
 */
export const confirmEmailField = z
  .string()
  .min(1, "Email Confirmation is required")
  .max(254, "Email must be 254 characters or less")
  .email("Invalid email address");

/**
 * Optional email field - validates format only if non-empty
 */
export const optionalEmailField = z
  .string()
  .max(254, "Email must be 254 characters or less")
  .refine(
    (val) =>
      val.trim() === "" || z.string().email().safeParse(val.trim()).success,
    { message: "Invalid email address" }
  );
